// extracted by mini-css-extract-plugin
export var imageContainer = "line-item-module--imageContainer--aDcXg";
export var itemTotalPrice = "line-item-module--itemTotalPrice--HqdM5";
export var lineItemWrap = "line-item-module--lineItemWrap--Bg9XZ";
export var priceColumn = "line-item-module--priceColumn--4fOMG";
export var quantityControl = "line-item-module--quantityControl--BvbK7";
export var remove = "line-item-module--remove--d53MQ";
export var title = "line-item-module--title--5L2ju";
export var totals = "line-item-module--totals--aZEC6";
export var variant = "line-item-module--variant--K9VDH";